import { DeviceConfigurationResponse } from './types';

type ForcedUpdateURL = DeviceConfigurationResponse['params']['ForcedUpdateURL'];

export function processForceUpgradeLinks(forcedUpdateUrls: NonNullable<ForcedUpdateURL>) {
  const links: Record<string, string> = {};

  for (let i = 0; i < forcedUpdateUrls.length; i++) {
    const link = forcedUpdateUrls[i];

    const [[key, value]] = Object.entries(link);

    links[key] = value;
  }

  return links;
}
